import { useState, useEffect } from "react";
import { MOBILE_BREAKPOINT } from "utils/viewportCss";

export { MOBILE_BREAKPOINT };

/** @deprecated Prefer useViewport for width/height + breakpoint flags */
export default function useMobileViewport() {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return true;
    const w = window.visualViewport?.width ?? window.innerWidth;
    return w <= MOBILE_BREAKPOINT;
  });

  useEffect(() => {
    const sync = () => {
      const w = window.visualViewport?.width ?? window.innerWidth;
      setIsMobile(w <= MOBILE_BREAKPOINT);
    };
    sync();
    window.addEventListener("resize", sync);
    window.addEventListener("orientationchange", sync);
    window.visualViewport?.addEventListener("resize", sync);
    return () => {
      window.removeEventListener("resize", sync);
      window.removeEventListener("orientationchange", sync);
      window.visualViewport?.removeEventListener("resize", sync);
    };
  }, []);

  return isMobile;
}
